/* eslint-disable prettier/prettier */
import { useTranslate } from '@im/react-localization';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';

export default function DefaultDialog(
  params: Readonly<{
    defaultWarning: number;
    handleOverrideDefaultConfirmation: (result: boolean) => void;
    keyName: string;
    keyValue: string;
  }>
) {
  const { defaultWarning, handleOverrideDefaultConfirmation, keyName, keyValue } =
    params;
  const translate = useTranslate();
  return (
    <Dialog
      aria-describedby="confirmation"
      aria-labelledby="confirmation"
      data-testid="vp-default-dialog"
      onClose={() => false}
      open={true}
    >
      <DialogTitle data-testid="vp-default-dialog-title">
        {translate('VendorDeals.ResellerMakeDefaultOverrideTitle')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {translate(
            `VendorDeals.MakeDefaultOverride${defaultWarning}Text`,
            {
              KeyName: keyName,
              KeyValue: keyValue,
            }
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          data-testid="vp-default-dialog-cancel-button"
          onClick={() => handleOverrideDefaultConfirmation(false)}
          variant="newOutlined"
        >
          {translate('VendorDeals.ResellerMakeDefaultOverrideReject')}
        </Button>
        {defaultWarning === 409 && (
          <Button
            data-testid="vp-default-dialog-overide-button"
            onClick={() => handleOverrideDefaultConfirmation(true)}
            variant="newContained"
          >
            {translate('VendorDeals.ResellerMakeDefaultOverrideConfirm')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
